import { Grid } from "@mui/material";
import { EditFieldHistoryComponent } from "@toorak/tc-common-fe-sdk";
import React from "react";
import { sanitizeCurrency } from "../../utils/formatChecks";
import { useDrawsStyles } from "./Draws.styles";

export const DrawViewModeTextField = ({
  label,
  value,
  type,
  editedData,
  isEditMode,
  valueEndAdornment,
  // New optional props for decrypt functionality (passed through to SDK)
  enableDecrypt,
  onDecrypt,
  canDecrypt
}: any) => {
  const classes = useDrawsStyles();
  const valLoc =
    type === "currency" ? sanitizeCurrency(value?.toString()) : value;

  let viewModeValue: React.ReactNode = (
    <p
      className={classes.itemValueText}
      data-testid="toorak-prePurchaseDrawAmount-value"
    >
      {valLoc || "__ __"}
    </p>
  );

  if (valueEndAdornment) {
    // When an inline adornment (e.g. the eye icon for bank details) is
    // supplied, render the value and the adornment side-by-side inside
    // the box. We zero the <p> margin so the icon vertically centers
    // with the value text. Existing callers that don't pass an
    // adornment keep the plain <p> above — no layout regression elsewhere.
    viewModeValue = (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 4,
          paddingRight: 4
        }}
      >
        <p
          className={classes.itemValueText}
          data-testid="toorak-prePurchaseDrawAmount-value"
          style={{ margin: 0 }}
        >
          {valLoc || "__ __"}
        </p>
        {valueEndAdornment}
      </div>
    );
  }

  return (
    <Grid item container xs={12} className={classes.fieldRow}>
      <div className={!isEditMode ? classes.itemBox : ""}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <p className={classes.itemSubHeaderText}>{label}</p>

          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              alignItems: "center"
            }}
          >
            {editedData && !isEditMode && (
              <EditFieldHistoryComponent
                auditList={editedData}
                fromSettelement={false}
                enableDecrypt={enableDecrypt}
                onDecrypt={onDecrypt}
                canDecrypt={canDecrypt}
              />
            )}
          </div>
        </div>
        {!isEditMode ? viewModeValue : null}
      </div>
    </Grid>
  );
};
